const streamSystemUser = "system-user";

export default streamSystemUser;
